import React, { useEffect, useState } from "react";
import styles from "./things-hub.module.scss";
import { ThingsHubSearch } from "@src/components/molecules/things-hub-search/things-hub-search";
import { HomepageCard } from "@src/components/molecules/homepage-card/homepage-card";
import { ThingsHubCards } from "@src/components/molecules/things-hub-cards/things-hub-cards";
import { ThingsHubDragAndDrop } from "@src/components/molecules/things-hub-drag-and-drop/things-hub-drag-and-drop";
import { useFeatureFlag } from "@src/hooks/use-feature-flag";

const cssClassName = "things-hub";

interface ThingsHubProps {
  cards: HomepageCard[];
  handleDragEnd: (event: any) => void;
}
export const ThingsHub = ({ cards, handleDragEnd }: ThingsHubProps) => {
  const [input, setInput] = useState("");
  const [isDragMode, setIsDragMode] = useState(false);
  const textareaRef = React.useRef<HTMLTextAreaElement | null>(null);

  // ticketing features get deactivated for namespace a6f962a7-77f7-46f2-9c72-59580255fdf8 (controlled via the "fakuma-hide-ticketing" feature flag)
  const isTicketingFeatureEnabled = useFeatureFlag("fakuma-hide-ticketing");

  useEffect(() => {
    if (!isDragMode) {
      textareaRef.current?.focus();
    }
  }, [isDragMode]);

  return (
    <div className={`${styles[cssClassName]}`}>
      {isTicketingFeatureEnabled && (
        <ThingsHubSearch
          input={input}
          isDragMode={isDragMode}
          setInput={setInput}
          textareaRef={textareaRef}
        />
      )}

      <ThingsHubCards
        cards={cards}
        isDragMode={isDragMode}
        handleDragEnd={handleDragEnd}
      />

      <ThingsHubDragAndDrop
        setIsDragMode={setIsDragMode}
        isDragMode={isDragMode}
      />
    </div>
  );
};
